// extracted by mini-css-extract-plugin
module.exports = {"DAFourN":"monitorUserStat_DAFourN__1Cg5m"};